import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

const FavoritesEmptyIcon = ({ color = '#fff', size = 20, ...props }) => (
  <svg
    viewBox="0 0 535 535"
    width={size}
    height={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m507.6 171.513-146.1-21.3-65.3-132.4c-11.7-23.6-45.6-23.9-57.4 0l-65.3 132.4-146.1 21.3c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7l130.7-68.7 130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6zm-139.5 140.8 23.7 138.4-124.3-65.3-124.3 65.3 23.7-138.4-100.6-98 139-20.2 62.2-126 62.2 126 139 20.2-100.6 98z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

FavoritesEmptyIcon.propTypes = propTypes;

export default FavoritesEmptyIcon;
